import { bindAll } from 'underscore';

import { map } from '@resn/gozer-math';
import { isMobile } from '@resn/gozer-env';
import getStore from 'core/store';

import ResizeService from '@resn/gozer-services/resize-service';
import ScrollService from 'utils/services/scroll-service';

const store = getStore();

import './index.scss';

const SectionBase = {
    props: {
        active: (props) => props.intersecting && !store.state.menu.opened,
        activeViewport: false,

        intersecting: false,
        bounds: { top: 0, bottom: 0, width: 0, height: 0 },

        scroll: 0,
        scrollSign: 0,
        scrollProgress: 0,
        scrollProgress0: 0,

        viewport: {
            width: window.innerWidth,
            height: window.innerHeight,
        },
        t: 0,

        scale: () => store.state.scale,
        mobile: () => store.state.mobile,

        firstCalc: false,
    },

    options: {
        overrideScroll: false,
        customScroll: false,
        boundsViewport: false,
    },

    onSetup() {
        bindAll(this, ['scrollHandler']);

        this.y = 0;
        /*         
        if (__DEV__) {
            this.debugProps = new DebugProps().setup({
                options: {
                    appendTo: this.el,
                },
                props: {
                    scroll: () => this.props.scroll,
                    scrollProgress: () => this.props.scrollProgress,
                    positionLayer: () => this.props.pointerPositionLayer,
                },
            });
        } */
    },

    onAfterSetup() {},

    onActive() {
        this.props.scroll = ScrollService.scroll;
        this.addListeners();
    },

    offActive({ firstTrigger }) {
        if (firstTrigger) return;
        this.removeListeners();
    },

    onActiveViewport() {},
    offActiveViewport() {},

    addListeners() {
        ScrollService.add(this.scrollHandler);
    },

    removeListeners(fromDestroy) {
        ScrollService.remove(this.scrollHandler);
        if (fromDestroy) console.log('removeListeners', this.constructor.name);
    },

    scrollHandler() {
        const prevScroll = this.props.scroll;
        const deltaScroll = ScrollService.scroll - prevScroll;
        this.props.scrollSign = Math.sign(deltaScroll);
        this.props.scroll = ScrollService.scroll;
    },

    update() {
        this.updateScrollProgress();
        this.updatePosition();
    },

    updateScrollProgress() {
        const { scroll, bounds, viewport, firstCalc } = this.props;

        const start = bounds.top - viewport.height;
        const end = bounds.bottom;
        this.props.scrollProgress = firstCalc ? map(scroll, start, end, 0, 1, true) : 0;

        const start0 = bounds.top - viewport.height;
        const end0 = bounds.bottom - viewport.height;
        this.props.scrollProgress0 = firstCalc ? map(scroll, start0, end0, 0, 1, true) : 0;
    },

    updatePosition() {
        if (this.options.overrideScroll) return;

        this.y = this.props.bounds.top - ScrollService.scroll;

        if (!isMobile) this.el.style.transform = `translateY(${this.y}px)`;
    },

    resize() {
        this.props.viewport = {
            width: ResizeService.windowWidth,
            height: ResizeService.windowHeight,
        };
    },

    calculateBounds(top) {
        const rect = this.el.getBoundingClientRect();
        const { viewport } = this.props;
        const { boundsViewport } = this.options;

        const width = boundsViewport ? viewport.width : rect.width;
        const height = boundsViewport ? viewport.height : rect.height;

        this.props.bounds = {
            top: top,
            bottom: top + height,
            width,
            height,
        };

        this.props.firstCalc = true;

        this.updatePosition();
    },

    onDestroy() {
        this.removeListeners();
    },
};

export default SectionBase;
